import React from 'react';
import AppShell from '@/components/layout/AppShell';
import { ownerNav } from '@/lib/navConfig';
import EmployeesManager from '@/components/employees/EmployeesManager';

export default function OwnerEmployees() {
  return (
    <AppShell nav={ownerNav} title="Daftar Karyawan" showBell>
      <EmployeesManager />
    </AppShell>
  );
}
